export const SENSITIVE_ATTRIBUTE = 'data-sensitive';
export const VISIBLE_INPUT_ATTRIBUTE = 'data-telemetry-visible';
export const IGNORE_ATTRIBUTE = 'data-telemetry-ignore';

const MASK = '••••••';
const MAX_WIDTH = 1600;
const JPEG_QUALITY = 0.6;
const CAPTURE_TIMEOUT_MS = 5000;

const MASKED_INPUTS_SELECTOR = [
  `input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([${VISIBLE_INPUT_ATTRIBUTE}])`,
  'textarea',
  'select',
].join(', ');

export const maskSensitiveContent = (root: Node): void => {
  if (!(root instanceof Element)) return;

  root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>(MASKED_INPUTS_SELECTOR).forEach(
    (field) => {
      if (field instanceof HTMLSelectElement) {
        field.replaceChildren(new Option(MASK, MASK, true, true));
        return;
      }
      if (field.value) {
        field.value = MASK;
        field.setAttribute('value', MASK);
      }
      if (field instanceof HTMLTextAreaElement) {
        field.textContent = field.value;
      }
    }
  );

  root.querySelectorAll(`[${SENSITIVE_ATTRIBUTE}]`).forEach((element) => {
    element.textContent = MASK;
  });
};

const shouldInclude = (node: Node): boolean => !(node instanceof Element && node.hasAttribute(IGNORE_ATTRIBUTE));

export const captureScreenshot = async (target: HTMLElement = document.body): Promise<Blob | null> => {
  try {
    const { domToBlob } = await import('modern-screenshot');
    const width = target.scrollWidth || window.innerWidth;
    return await domToBlob(target, {
      type: 'image/jpeg',
      quality: JPEG_QUALITY,
      scale: width > MAX_WIDTH ? MAX_WIDTH / width : 1,
      timeout: CAPTURE_TIMEOUT_MS,
      font: false,
      filter: shouldInclude,
      onCloneNode: maskSensitiveContent,
    });
  } catch (error) {
    console.warn('[telemetry] screenshot failed', error);
    return null;
  }
};
